import Mutations from '../../odata/mutations';

export default { ...new Mutations('interview'), ...new Mutations('interviews') };
